// Two business numbers — never interchangeable.
// Customer service (humans): call or text 689-345-RENT.
// Automated order updates (Twilio sender): 833-805-GEAR.
export const CS_PHONE_E164 = "+16893457368";
export const CS_PHONE_DISPLAY = "689-345-RENT (7368)";
export const CS_TEL_HREF = `tel:${CS_PHONE_E164}`;
export const CS_SMS_HREF = `sms:${CS_PHONE_E164}`;
export const CS_LABEL = `Call or Text: ${CS_PHONE_DISPLAY}`;

export const AUTO_PHONE_E164 = "+18338054327";
export const AUTO_PHONE_DISPLAY = "833-805-GEAR (4327)";
export const AUTO_LABEL = `Automated Order Updates: ${AUTO_PHONE_DISPLAY}`;
